import { mkInput, mkType, SchemaToType } from '@main/schema-utils';

/**
 * Input for filtering scanned object file types
 */
export const ScannedObjectFileTypesFiltersInput = mkInput({
  name: 'ScannedObjectFileTypesFiltersInput',
  comment: 'Input for filtering scanned object file types',
  fields: {
    dataSiloId: {
      comment: 'The ID of the data silo',
      type: 'id',
      modelName: 'dataSilo',
    },
  },
});

/** Override type */
export type ScannedObjectFileTypesFiltersInput = SchemaToType<
  typeof ScannedObjectFileTypesFiltersInput
>;

/**
 * Output for getting scanned object file types
 */
export const ScannedObjectFileTypesOutput = mkType({
  name: 'ScannedObjectFileTypesOutput',
  comment: 'Output for getting scanned object file types',
  fields: {
    uniqueFileTypes: {
      comment: 'The unique file types',
      type: 'string',
      list: true,
    },
  },
});

/** Override type */
export type ScannedObjectFileTypesOutput = SchemaToType<
  typeof ScannedObjectFileTypesOutput
>;
